<template lang="pug">
.h-vertical-align-container(v-if='modalShow')
  .modal__overlay
  .modal__wrapper.modal__wrapper--marketingConsent
    form.modal__marketingconsent(v-on:submit.prevent='updateUser__invoke(updatedProfile)')
        h1 Marketing Consent
        .marketingConsent--container
          p Flixel can send me product updates and offers via email. You can opt-out at any time.
        button.btn.btn--purpleLight(type="submit" v-model="updatedProfile.marketing_consent" @click="updatedProfile.marketing_consent = true") Yes
        button.btn.btn--white(type="submit" v-model="updatedProfile.marketing_consent" @click="updatedProfile.marketing_consent = false") No
</template>

<script>
import { _ } from 'vue-underscore';
import ProfileService from 'services/profile.es6.js';
import AuthService from 'services/auth.es6.js';
import utilities from 'services/utilities.es6.js';

const axios = require('axios');

export default {
  name: 'marketingConsent',
  data() {
    return {
      modalShow: '',
      profile: '',
      updatedProfile: {
        marketing_consent: '',
      },
    };
  },
  mounted() {
    this.profile = JSON.parse(localStorage.getItem('profile'));
    if (this.profile !== null) {
      if (this.profile.marketing_consent === null && this.$router.currentRoute.name !== 'settings.account') {
        this.modalShow = true;
      }
    }
  },
  watch: {
    '$route': function () {
      this.profile = JSON.parse(localStorage.getItem('profile'));
      if (this.profile !== null) {
        if (this.profile.marketing_consent === null && this.$router.currentRoute.name !== 'settings.account') {
          this.modalShow = true;
        }
      }
    },
  },
  methods: {
    updateUser__success(data) {
      ProfileService.version++;
      AuthService.updateUser('profile', data[0]);
      this.modalShow = false;
    },
    updateUser__error(error) {
      const key = _.keys(error)[0];
      const msg = error[key][0] || 'There is an error with your form';
    },
    readyForm(profile) {
      const profileForm = utilities.createFormData(profile);
      return profileForm;
    },
    updateUser__invoke(profile) {
      const profileForm = this.readyForm(profile);
      const profilePromise = ProfileService.update(profileForm);
      axios.all([profilePromise])
        .then(this.updateUser__success, this.updateUser__error);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/MarketingConsent.vue